export function isItemInBox(item) {
  return !!item.boxItemsId;
}